import { MenuItem, Select } from '@mui/material';

import { useSelector } from 'react-redux';
import { useState } from 'react';
import { selectStatus } from '../helper/filterExpenseEntry';

const FilterStatus = ({ setExpenseEntriesData }) => {
  const { allExpenseEntriesData } = useSelector((state) => state.expenseEntry);
  const [defaultSelect, setDefaultSelect] = useState('all');

  const handleSelect = async (event) => {
    setDefaultSelect(event.target.value);
    const seletctedData = await selectStatus(event.target.value, allExpenseEntriesData.data.data);
    setExpenseEntriesData(seletctedData);
  };
  return (
    <Select size='small' value={defaultSelect} onChange={handleSelect}>
      <MenuItem value='all' id='all'>
        Select Status
      </MenuItem>

      {/* <MenuItem value='BANK' id={1}>
        BANK
      </MenuItem> */}

      <MenuItem value='CASH' id={2}>
        CASH
      </MenuItem>
    </Select>
  );
};

export default FilterStatus;
